import { getOptionById, SelectOption } from 'components/Select'
import { UserWorkspaceForFormDTO } from 'features/user/forms/UserPublisherForm/types'
import { WorkspaceSlice } from '../../hooks/useGetWorkspaceOptions'
import { CommonSchema } from './common'

type Props = {
  userWorkspace: UserWorkspaceForFormDTO
  workspaceOptions: SelectOption<WorkspaceSlice>[]
}

export const editSchemaDefault = ({
  userWorkspace: { role, userId, workspaceId },
  workspaceOptions,
}: Props): CommonSchema => {
  const currentWorkspaceOption: SelectOption<WorkspaceSlice> | undefined =
    getOptionById<WorkspaceSlice>(workspaceId, workspaceOptions)
  if (!currentWorkspaceOption) throw Error('Given Workspace ID does not match Workspaces list')

  return {
    role,
    userId,
    workspaceId: currentWorkspaceOption,
  }
}
